import React, { useEffect } from 'react'
import TableMui from 'src/components/TableMui'
import { TableMuiLabel } from 'src/components/TableMui/styles'
import { Container, checkButtonStyle } from './PendingReceivementsTable.styles'
import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { actions } from '../../PendingReceivementsState'
import Button from 'src/components/Button'
import { useHistory } from 'react-router-dom'
import { BadgeStatus, PendingReceivement } from '../../PendingReceivementsTypes'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'

export const PendingReceivementsTable = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const pendingReceivements = useSelector((state) => state.pendingReceivements.pendingReceivements)

  const { fc, validateFc } = useFulfillmentCenter()

  useEffect(() => {
    validateFc()
  }, [validateFc])

  React.useEffect(() => {
    dispatch(actions.getPendingReceivements(fc.id))
  }, [dispatch, fc])

  const onClickInvoiceCheck = (receivement) => {
    dispatch(actions.setBadgeStatus(BadgeStatus.PENDING))
    history.push(`/pending-receivement/${receivement.idReceivement}/badge`)
  }

  const resolveRequestAction = (receivement: PendingReceivement) => ({
    ...receivement,
    requestAction: (
      <Button
        type='button'
        text='receivement.invoiceReturn.invoice.check'
        style={checkButtonStyle}
        onClick={() => onClickInvoiceCheck(receivement)}
        testId={`check-receivement-${receivement.idReceivement}-button`}
      />
    ),
  })

  return (
    <Container>
      <TableMui
        columns={[
          { id: 'idReceivement', label: 'Recebimento' },
          { id: 'supplierName', label: 'Fornecedor' },
          { id: 'dateReceivement', label: 'Data Recebimento', isDate: true },
          { id: 'waitingTime', label: 'Tempo Aguardando', isDate: true },
          { id: 'dock', label: 'Doca' },
          { id: 'requestAction', label: 'Solicitação de NF' },
        ]}
        rows={pendingReceivements.map((pendingReceivement) => resolveRequestAction(pendingReceivement))}
        emptyLabel='No momento, não há nenhum recebimento aguardando aprovação.'
        tableLabel={(
          <TableMuiLabel>
            Aguardando Aprovação
          </TableMuiLabel>
        )}
        rowsPerPageLimit={30}
        enablePagination
        thinLine
      />
    </Container>
  )
}
